export default __webpack_public_path__ + "static/media/b_boletin_cooperando.2e1ef981.jpg";